import { FC, SVGProps } from 'react';

export const ArrowDownIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M6.96317 10.1868C6.51407 9.7377 5.78593 9.7377 5.33683 10.1868C4.88772 10.6359 4.88772 11.364 5.33683 11.8131L15.3368 21.8131C15.7859 22.2623 16.5141 22.2623 16.9632 21.8131L26.9632 11.8131C27.4123 11.364 27.4123 10.6359 26.9632 10.1868C26.5141 9.7377 25.7859 9.7377 25.3368 10.1868L16.15 19.3736L6.96317 10.1868Z"
			fill="currentColor"
		/>
	</svg>
);
